<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        top: 260px;
        left: 34px;
        width: 41px;
    }
</style>

<svg id="today-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 115.83 25.52">
    <g>
        <path {fill} class="cls-1" d="M7.14,4.68H0V.43H19.45V4.68h-7.14V25.09H7.14V4.68Z"/>
        <path {fill} class="cls-1" d="M26.6,23.97c-1.78-1.03-3.16-2.5-4.13-4.41-.97-1.91-1.45-4.17-1.45-6.79v-.03c0-2.62,.49-4.88,1.46-6.78,.97-1.9,2.35-3.37,4.14-4.4,1.78-1.03,3.89-1.55,6.32-1.55s4.55,.52,6.32,1.56c1.78,1.04,3.15,2.5,4.12,4.4s1.45,4.16,1.45,6.78v.03c0,2.62-.48,4.88-1.45,6.78-.97,1.9-2.34,3.37-4.11,4.41-1.77,1.04-3.88,1.56-6.33,1.56s-4.55-.52-6.33-1.55Zm9.86-3.86c.99-.69,1.75-1.66,2.28-2.91,.54-1.25,.8-2.73,.8-4.43v-.03c0-1.71-.27-3.19-.81-4.44-.54-1.25-1.31-2.22-2.3-2.9-.99-.68-2.16-1.02-3.5-1.02s-2.52,.34-3.51,1.02c-1,.68-1.77,1.64-2.31,2.89s-.81,2.73-.81,4.45v.03c0,1.71,.27,3.19,.81,4.44,.54,1.25,1.31,2.22,2.3,2.91s2.16,1.03,3.52,1.03,2.54-.34,3.53-1.03Z"/>
        <path {fill} class="cls-1" d="M49.02,.43h9.42c2.47,0,4.58,.47,6.33,1.42,1.75,.95,3.09,2.33,4.02,4.14,.93,1.82,1.4,4.03,1.4,6.64v.03c0,2.61-.46,4.84-1.39,6.7-.93,1.86-2.27,3.28-4.02,4.26-1.75,.98-3.87,1.47-6.34,1.47h-9.42V.43Zm8.8,20.39c1.54,0,2.83-.31,3.89-.92,1.05-.62,1.85-1.53,2.4-2.73,.55-1.21,.82-2.7,.82-4.48v-.03c0-1.71-.28-3.16-.84-4.34-.56-1.18-1.37-2.08-2.43-2.69-1.06-.61-2.34-.91-3.85-.91h-3.64V20.82h3.64Z"/>
        <path {fill} class="cls-1" d="M80.4,.43h4.56V5.21h-1.57l-6.17,19.88h-5.42L80.4,.43Zm-2.7,14.82h11.5l1.26,3.86h-14.03l1.26-3.86Zm5.79-10.03V.43h2.99l8.6,24.66h-5.43l-6.15-19.88Z"/>
        <path {fill} class="cls-1" d="M102.07,15.88L93.5,.43h5.57l5.54,10.53h.12L110.24,.43h5.59l-8.6,15.45v9.21h-5.16V15.88Z"/>
    </g>
</svg>